// ---------------------------------------------- modules import
import React, { FunctionComponent } from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import Details from "./details";
import List from "./list";
import ReaderList from "./readerList";

import { useAuth } from "./hooks";

// ---------------------------------------------- the component
const PinnedPost: FunctionComponent = () => {
  // ---------------------------------------------- router state
  let match = useRouteMatch();

  // ---------------------------------------------- local state
  const { areLoaded, isEmptied } = useAuth();

  // ---------------------------------------------- content
  return !areLoaded ? null : isEmptied || !match ? (
    <Redirect to="/login" />
  ) : (
    <>
      <Route exact path={match.path} component={List} />

      <Switch>
        <Route
          path={`${match.path}/reader-list/:pinned_post_id`}
          component={ReaderList}
        />

        <Route path={`${match.path}/:pinned_post_id`} component={Details} />
      </Switch>
    </>
  );
};

export default PinnedPost;
